// extracted by mini-css-extract-plugin
export var button = "ReferralAd-module--button--Ktnjc";
export var container = "ReferralAd-module--container--+LmFC";
export var icon = "ReferralAd-module--icon--+0blw";
export var image = "ReferralAd-module--image--lZNIM";
export var link = "ReferralAd-module--link--P7ggm";
export var linkButton = "ReferralAd-module--linkButton--SjlLZ";
export var text = "ReferralAd-module--text--FMWuj";
export var textContainer = "ReferralAd-module--textContainer--NmzNA";